module.exports = __webpack_public_path__ + "static/media/marker.0725f339.svg";